import { UrlObject } from 'url';

export type FacetFilter = {
	facet?: string;
	value?: string;
};

const toFacetSize = (size: string) => {
	const value = Number(size);
	return Number.isFinite(value) ? value.toFixed(1) : size;
};

export const toFootwearSize = (size?: string) =>
	size && Number.isFinite(Number(size)) ? toFacetSize(size) : undefined;

const toFacetQuery = ({ facet, value }: FacetFilter) =>
	facet && value ? encodeURIComponent(`${facet}:"${value}"`) : undefined;

export const buildFacetHref = (href: string, filters: FacetFilter[]): string | UrlObject => {
	const facets = filters.map(toFacetQuery).filter((facet): facet is string => !!facet);
	if (!facets.length) {
		return href;
	}
	const [pathname, search = ''] = href.split('?');
	const params = new URLSearchParams(search);
	return {
		pathname,
		query: {
			...Object.fromEntries(params),
			facet: [...params.getAll('facet').map((facet) => encodeURIComponent(facet)), ...facets],
		},
	};
};

export type GenderHrefs = Partial<Record<string, string>>;

const toGenderKey = (gender: string) =>
	gender
		.normalize('NFD')
		.replace(/\p{Diacritic}/gu, '')
		.trim()
		.toLowerCase();

export const resolveCtaHref = ({
	genderHrefs = {},
	gender,
	size,
	sizeFacet,
}: {
	genderHrefs?: GenderHrefs;
	gender?: string;
	size?: string;
	sizeFacet?: string;
}) => {
	const href = gender ? genderHrefs[toGenderKey(gender)] : undefined;
	return href
		? buildFacetHref(href, [{ facet: sizeFacet, value: toFootwearSize(size) }])
		: undefined;
};
